"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTableExportName = exports.createExportName = void 0;
const is_defined_1 = require("../is-defined");
const createExportName = (name, wsName, periodStart, periodEnd, extension) => ([name.replace(' ', '_'), wsName.replace(' ', '_'), periodStart.format('YYYY-MM-DD'), periodEnd.format('YYYY-MM-DD'), 'Dayswaps'].join('_') + extension);
exports.createExportName = createExportName;
const createTableExportName = (config) => ([
    config.tableName.replace(/\s/g, '_'),
    config.workspaceName.replace(/\s/g, '_'),
    (0, is_defined_1.isDefined)(config.extraSeparator) ? config.extra?.().replace(config.extraSeparator, '_') : config.extra?.(),
    'Dayswaps'
].filter(is_defined_1.isDefined).join('_'));
exports.createTableExportName = createTableExportName;
